module.exports = __webpack_public_path__ + "img/centralafricanrepublic.aa3c4a86.svg";